import AcknowledgementModal from "./AcknowledgementModal";
export default AcknowledgementModal;
